(ns ycweb.app.common
  (:require
   ["@sentry/browser" :as sentry]
   [ycweb.util.core :as yuc]))

(defn init-sentry []
  (when (not= (yuc/env :build-number "dev") "dev")
    (. sentry init
      (clj->js
        {:dsn "https://8106741a71874fd3b46cb692fe5bcc50@o26510.ingest.sentry.io/5871544"
         :ignoreErrors
         ["UnhandledRejection" ;; Scrapers throwing errors on font loading
          "top.GLOBALS" ;; Global browser extensions
          "originalCreateNotification" ;; Extension Bug
          "canvas.contentDocument"
          "MyApp_RemoveAllHighlights"
          "http://tt.epicplay.com"
          "Can't find variable: ZiteReader"
          "jigsaw is not defined"
          "ComboSearch is not defined"
          "http://loading.retry.widdit.com/"
          "atomicFindClose"
          "fb_xd_fragment" ;; Facebook borked
          "bmi_SafeAddOnload"
          ;; ISP "optimizing" proxy - `Cache-Control: no-transform` seems to reduce this. (thanks @acdha)
          ;; See http://stackoverflow.com/questions/4113268/how-to-stop-javascript-injection-from-vodafone-proxy

          "EBCallBackMessageReceived"
          ;; See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
          "conduitPage"
          "Script error."

          "TypeError: Failed to fetch" ;; Benign network errors mostly from GA
          "TypeError: NetworkError when attempting to fetch resource."
          "globalThis is not defined" ;;Error from facebook pixel
          "Load failed" ;; Apple issue with Fetch API @ GTM
          ]

         :denyUrls
         [#"(?i)graph\.facebook\.com"
          #"(?i)connect\.facebook\.net/en_US/all\.js"
          #"(?i)eatdifferent\.com\.woopra-ns\.com"
          #"(?i)static\.woopra\.com/js/woopra\.js"
          #"(?i)extensions/" #"(?i)^chrome://"
          #"(?i)^(chrome|moz|safari(-web)?)-extension://"
          #"(?i)127\.0\.0\.1:4001/isrunning"
          #"(?i)webappstoolbarba\.texthelp\.com/"
          #"(?i)metrics\.itunes\.apple\.com\.edgesuite\.net/"
          #"(?i)/(gtm|ga|analytics)\.js"]}))))
